<template>
  <v-card class="modal-peridic-ielty">
    <v-card-title class="font-weight-bold px-5">
      Báo cáo học tập cuối kỳ
      <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="pa-3 mb-5">
      <GoodTable
        :rows="listComment"
        :columns="columns"
        :noneBorder="noneBorder"
        :nodata="nodata"
        :lineNumbers="{ show: false }"
        height="600px"
      >
        <template #name="item">
          <div>
            <div style="margin-bottom: 8px">{{item.name}}</div>
            <div style="margin-bottom: 8px">{{item.classCode}}</div>
            <div style="margin-bottom: 8px">{{_.get(item, 'classTag.name')}}</div>
          </div>
        </template>
        <template #teacher="item">
          <div>
            <div>Giáo viên: {{ item.teacher.teacherCode }} - {{ item.teacher.teacherName }}</div>
            <div>{{item.createdAt}}</div>
          </div>
        </template>
        <template #evaluationAI="item">
          <div>
            <div class="frame-comment">
              <div class="d-flex justify-space-between">
                <div class="tag-comment">Nhận xét học tập cuối kỳ</div>
                <div style="color:#FF753A" class="d-flex" v-if="item.isShareCare">
                  <span class="my-auto mr-2">Đã chia sẻ</span>
                  <svg
                    class="my-auto"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      width="16"
                      height="16"
                      fill="url(#pattern0_19142_415)"
                    />
                    <defs>
                      <pattern
                        id="pattern0_19142_415"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlink:href="#image0_19142_415"
                          transform="scale(0.0625)"
                        />
                      </pattern>
                      <image
                        id="image0_19142_415"
                        width="16"
                        height="16"
                        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAE2SURBVDiN7dHPK4MBHMfx9/fxaLVSloPMRXme3JeDf8Cv+AuUMDbmQKTsonZxkhpO21iTlFqODspBkkQ5uDhsq+UwLjJlS7J9HZ6SlfAH7HP+vOrz7Qv1yH9KGrBmEVag0SfxuwcFIWBvINpt/omD9hxoFOWaovGkEQwKVgx0Ckj+ukCD1gKwjnCD8d5L6/0LBWsbmAA5wNs+Khq09hG9lFhuq3Z25xIia8AFLgZ5zJbw2DugYyC7PGcmJU3FADyobGrAnv/C09ayg+Wcj4YBB1spB5PEm/FLmgqAqL+rCbNyDPSAhEBbgFXgDCGMVl/BCAMjCAnasjMSoVrzBR3vaMZlnqD4AEE55c09jLt8iNLn9DRGPBcS0O+nGgCSyhcxzX7gCvQIKQ/J3m0JWATyQPQnXI+TT70Ia+Fn+btqAAAAAElFTkSuQmCC"
                      />
                    </defs>
                  </svg>
                </div>
              </div>
              <div class="d-flex my-2">
                <div class="content-bold mr-2">{{item.evaluationAI[0].title}}</div>
                <div>
                    <VoteStar :value='item.evaluationAI[0].star' sizeStar="16"></VoteStar>
                </div>
              </div>
              <div>{{item.evaluationAI[0].content && item.evaluationAI[0].content.length > 125 ? item.evaluationAI[0].content.substring(0, 122) + '...' : item.evaluationAI[0].content}}</div>
              <div class="other-comment" v-if="item.otherComment" @click="handleAction('view_other_comment', item.otherComment)">Nhận xét từ giáo viên khác</div>
            </div>
            <div class="d-flex justify-end align-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <div class="view-comment mr-1 active" @click="handleViewStudyReport(item.reportResultLink)"  v-on="on">
                        Xem trước báo cáo
                    </div>
                </template>
                <span>{{item.isShareCare ? 'Không gửi link này cho phụ huynh' : 'Chia sẻ nhận xét để mở xem báo cáo học tập cuối kỳ'}}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <div
                    v-on="!item.isShareCare ? on : ''"
                    v-bind="attrs"
                    class="view-comment"
                    :class="item.isShareCare ? 'active' : ''"
                    @click="item.isShareCare ? handleCopyLink(item.reportResultLinkCopy) : ''"
                  >
                    Copy link gửi phụ huynh
                  </div>
                </template>
                <span>Chia sẻ nhận xét để mở xem báo cáo học tập cuối kỳ</span>
              </v-tooltip>
            </div>
          </div>
        </template>
        <template #action="item">
          <div class="d-flex align-start pt-2" style="height: 100%">
            <div class="d-flex justify-space-around align-center w-100">
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <button
                    v-on="on"
                    v-bind="attrs"
                    class="btn btn-sm btn-primary"
                    :disabled="item.isShareCare"
                    @click="handleAction('edit', item)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M4.75583 14.4105L12.5 6.66631L8.82167 2.98798L1.0775 10.7321C0.970887 10.8389 0.895153 10.9725 0.858334 11.1188L0 15.488L4.36833 14.6296C4.515 14.593 4.64917 14.5171 4.75583 14.4105ZM15 4.16631C15.3125 3.85377 15.488 3.42992 15.488 2.98798C15.488 2.54604 15.3125 2.12219 15 1.80964L13.6783 0.487978C13.3658 0.175526 12.9419 0 12.5 0C12.0581 0 11.6342 0.175526 11.3217 0.487978L10 1.80964L13.6783 5.48798L15 4.16631Z"
                        :fill="item.isShareCare ? '#BFBFBF' :'#E91E63'"
                      />
                    </svg>
                  </button>
                </template>
                <span>Chỉnh sửa nhận xét</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <button
                    v-bind="attrs"
                    v-on="on"
                    class="btn btn-sm btn-primary"
                    :disabled="item.isShareCare"
                    @click="handleAction('share', item)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M14.7976 5.77734L10.7067 10.2773C10.5788 10.4258 10.419 10.5 10.2273 10.5C10.142 10.5 10.0533 10.4805 9.96094 10.4414C9.68395 10.3086 9.54545 10.0781 9.54545 9.75V7.5H7.84091C5.54688 7.5 3.99148 8.01172 3.17472 9.03516C2.32955 10.1055 2.06676 11.9531 2.38636 14.5781C2.40767 14.7578 2.33665 14.8906 2.1733 14.9766C2.11648 14.9922 2.07386 15 2.04545 15C1.93182 15 1.83949 14.9492 1.76847 14.8477C1.69744 14.7383 1.62287 14.6172 1.54474 14.4844C1.46662 14.3516 1.32635 14.084 1.12393 13.6816C0.92152 13.2793 0.745739 12.8906 0.596591 12.5156C0.447443 12.1406 0.310725 11.6953 0.186435 11.1797C0.062145 10.6641 0 10.1875 0 9.75C0 9.36719 0.012429 9.01172 0.0372869 8.68359C0.0621449 8.35547 0.111861 8.00391 0.186435 7.62891C0.261009 7.25391 0.36044 6.91016 0.48473 6.59766C0.60902 6.28516 0.775923 5.9668 0.98544 5.64258C1.19496 5.31836 1.43821 5.0293 1.7152 4.77539C1.99219 4.52148 2.32777 4.28125 2.72195 4.05469C3.11612 3.82812 3.55824 3.63867 4.0483 3.48633C4.53835 3.33398 5.10476 3.21484 5.74751 3.12891C6.39027 3.04297 7.08807 3 7.84091 3H9.54545V0.75C9.54545 0.421875 9.68395 0.191406 9.96094 0.0585938C10.0533 0.0195313 10.142 0 10.2273 0C10.4119 0 10.5717 0.0742188 10.7067 0.222656L14.7976 4.72266C14.9325 4.87109 15 5.04688 15 5.25C15 5.45312 14.9325 5.62891 14.7976 5.77734Z"
                        :fill="item.isShareCare ? '#BFBFBF' :'#E91E63'"
                      />
                    </svg>
                  </button>
                </template>
                <span>Chia sẻ nhận xét</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{on, attrs}">
                  <button
                    v-on="on"
                    v-bind="attrs"
                    class="btn btn-sm btn-primary"
                    @click="handleAction('view', item)"
                  >
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="21" height="21" fill="url(#pattern0_19142_215)" />
                      <defs>
                        <pattern
                          id="pattern0_19142_215"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            xlink:href="#image0_19142_215"
                            transform="scale(0.0416667)"
                          />
                        </pattern>
                        <image
                          id="image0_19142_215"
                          width="24"
                          height="24"
                          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJ+SURBVEiJ7ZTNb0xhFMZ/573DxkekMZ1bOm4Jq25kBEGXRC26VF8hpcb3Qv+D+Q9IJE3RMRWhKTsW1E5YaIOopRDzlZiPpg1qN/c9FlNNe+emmcSiG2f5nud5znOS5z3wv1a6pFlgJXplbW1drQUg8isy01odnPunAUoqUt5SOCLQC3QBHQFIFnitmMex/OYXQqrW1AAFqXjnTqKSArYH2j7ghOh8QTQVy917uOyAqnehzap/HzgUwD0Q4UY09/MTdOp0PJ+wYq6DngrYGxdj+1qzI6WGAVXvbMKq8xR0c0D8Uiyfvh3imnL8/GVEBwPPRTGmpzV79+PCgO/x5G4j9iWwIeg8lk+fASh75/ahclFUatZh2M0Ov51/f4TKiQBv1og9GM1lPkjJO79VVCeBjUGHRuyuaC7zoewl96P2FRCZb/lq7QG3mJn43t6/xxgmGvfTijV2rzFqx8LEgdrG3NxUHWuTi8QBHCNOEsAt/nwPaCNdWo11xowiIc36AtCpAKLiN/gTnU9Tp1BPV7iINf4xhGpYbzqeTwD4qneAxTmvqbVDAKX2QiKw3V8LFd+h17RlR7JG5QgwG4TUowhtxfSkVbMfuKuiGbW2yy1mJgAch4EQczMi0r3pWzq3ENNKR3KnWvsMaF9qhKuxQjoYxTrH67+myq2lcAriaE/s270pCHy0Skefq9aMgBxeoiQ6an256Rbj7wBTai8kHIcBVY4HzDzX1av63K9DlQVqmLOS139SlBSwI6TdeC6Ez2ol5RaGR4PgZY7dUWfaW99tVXpBu4BtAchX4I2IPI7mfowLT0KT1PS5LsVOr/GdSAuA49dm3PKD381y/9fK1h/1m/tKCGd7uwAAAABJRU5ErkJggg=="
                        />
                      </defs>
                    </svg>
                  </button>
                </template>
                <span>Xem toàn bộ nhận xét</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </GoodTable>
    </v-card-text>
    <v-dialog
        v-model="showDialog"
        v-if="showDialog"
        max-width="1200"
        :retain-focus="false"
      >
        <ViewAndEditComment :type="typeAction" :item="selectionItem" @action="handelActionDialog"/>
      </v-dialog>
  </v-card>
</template>

<script>
import GoodTable from '@/components/common/GoodTable.vue';
import VoteStar from '@/components/common/VoteStar.vue';
import ContactRepository from '@/services/ContactRepository';
import ViewAndEditComment from './ViewAndEditComment.vue';

export default {
  components: { GoodTable, VoteStar, ViewAndEditComment },
  props: {
    lmsCoreUserID: {
      type: Number,
      default: 0,
    },
    listComment: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        {
          label: 'Báo cáo học tập cuối kỳ',
          field: 'name',
          thWidth: '220px',
          customRow: true,
        },
        {
          label: 'Giáo viên',
          field: 'teacher',
          thWidth: '250px',
          customRow: true,
        },
        {
          label: 'Nhận xét',
          field: 'evaluationAI',
          customRow: true,
        },
        {
          label: 'Thao tác',
          field: 'action',
          thWidth: '120px',
          customRow: true,
        },
      ],
      noneBorder: true,
      nodata: 'Không có dữ liệu',
      showDialog: false,
      typeAction: 'view',
      selectionItem: null,
    };
  },
  // async created() {
  //   await this.getListCommentStation();
  // },
  methods: {
    handleCopyLink(link) {
      navigator.clipboard.writeText(link).then(() => {
        this.$swal({
          toast: true,
          title: 'Sao chép thành công',
          icon: 'success',
          position: 'top',
          showConfirmButton: false,
          timer: 2000,
        });
      });
    },
    handleViewStudyReport(link) {
      if (link) {
        window.open(link, '_blank');
      }
    },
    closeModal() {
      this.$emit('close');
    },
    async handleAction(type, item) {
      this.selectionItem = item;
      if (type !== 'share') {
        this.typeAction = type;
        this.showDialog = true;
      }
      if (type === 'share') {
        this.$swal({
          title: 'Chia sẻ nhận xét',
          text: 'Bạn có chắc chắn muốn chia sẻ nhận xét buổi học với phụ huynh học sinh ? Nhận xét sẽ được hiển thị trên web và app gia sư khi bạn xác nhận',
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Hủy',
          showCancelButton: true,
          confirmButtonColor: '#CE2375',
        }).then(async (res) => {
          if (res.isConfirmed) {
            await this.shareComment(this.selectionItem);
          }
        });
      }
    },
    async shareComment(item, commentOfTeacher, isSave = false) {
      // eslint-disable-next-line no-param-reassign
      item.isShareCare = true;
      const body = {
        ...item,
        commentOfTeacher,
      };
      const res = await ContactRepository.updateCommentStation(item.id, body);
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.$swal({
          type: 'success',
          title: 'Thành công !',
          text: isSave ? 'Lưu và chia sẻ thành công !' : 'Chia sẻ thành công',
        });
        this.showDialog = false;
        await this.getListCommentStation();
      }
    },
    async editComment(item, commentOfTeacher) {
      console.log(commentOfTeacher);
      const res = await ContactRepository.updateCommentStation(item.id, { ...item, commentOfTeacher });
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.$swal({
          type: 'success',
          title: 'Thành công !',
          text: 'Chỉnh sửa thành công !',
        });
        await this.getListCommentStation();
      }
      this.showDialog = false;
    },
    async handelActionDialog(event, commentOfTeacher) {
      switch (event) {
        case 'edit':
          this.typeAction = event;
          await this.editComment(this.selectionItem, commentOfTeacher);
          break;
        case 'edit_and_share':
          await this.shareComment(this.selectionItem, commentOfTeacher, true);
          break;
        case 'share':
          await this.shareComment(this.selectionItem, commentOfTeacher);
          break;
        case 'close':
          this.showDialog = false;
          this.typeAction = 'view';
          break;
        case 'change_type_edit':
          this.typeAction = 'edit';
          break;
        default:
          break;
      }
    },
    async getListCommentStation() {
      const params = {
        lms_core_user_id: this.lmsCoreUserID,
      };
      const res = await ContactRepository.getListCommentStation(params);
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.listComment = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.frame-comment {
  margin: 8px 0px;
  border-radius: 5px;
  background: #ddf8fc;
  padding: 12px 16px 20px 12px;
  .tag-comment {
    border-radius: 15px;
    padding: 4px 8px;
    background: #00d3c7;
    color: #fff;
    //font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 18px */
  }
  .content-bold {
    color: #000;
    //font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 18px */
  }
  .other-comment {
    color: #08F;
    //font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 200% */
    letter-spacing: 0.5px;
    cursor: pointer;
  }
}
.view-comment {
    height: 26px;
    margin-bottom: 4px;
    color: #FFF;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 18px */
    border-radius: 5px;
    background: #D2D2D2;
    padding: 4px 8px;
    cursor: pointer;
    &.active {
      background: #189EFF;
    }
}
</style>
